import {
  ADD_ETHNICITY,
  ADD_ETHNICITY_FAILURE,
  ADD_ETHNICITY_SUCCESS,
  EDIT_ETHNICITY,
  EDIT_ETHNICITY_FAILURE,
  EDIT_ETHNICITY_SUCCESS,
} from '../Actiontype';

export const AddEthnicity = data => ({
  payload: data,
  type: ADD_ETHNICITY,
});
export const AddEthnicitySuccess = response => ({
  payload: response,
  type: ADD_ETHNICITY_SUCCESS,
});
export const AddEthnicityFailure = response => ({
  payload: response,
  type: ADD_ETHNICITY_FAILURE,
});
export const EditEthnicity = data => ({
  payload: data,
  type: EDIT_ETHNICITY,
});
export const EditEthnicitySuccess = response => ({
  payload: response,
  type: EDIT_ETHNICITY_SUCCESS,
});
export const EditEthnicityFailure = response => ({
  payload: response,
  type: EDIT_ETHNICITY_FAILURE,
});
